import { useEffect, useRef, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import './MemberEmailCopy.css';

type MemberEmailCopyProps = {
  email: string;
  copyLabel: string;
  copiedLabel: string;
};

export function MemberEmailCopy({
  email,
  copyLabel,
  copiedLabel,
}: MemberEmailCopyProps) {
  const [copied, setCopied] = useState(false);
  const copyTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (copyTimeoutRef.current !== null) {
        window.clearTimeout(copyTimeoutRef.current);
      }
    };
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);

      if (copyTimeoutRef.current !== null) {
        window.clearTimeout(copyTimeoutRef.current);
      }

      copyTimeoutRef.current = window.setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="liks-members__person-email">
      <span className="liks-members__person-email-text">{email}</span>
      <button
        type="button"
        className="liks-members__email-copy"
        aria-label={copied ? copiedLabel : copyLabel}
        onClick={() => {
          void handleCopy();
        }}
      >
        {copied ? (
          <Check strokeWidth={2} aria-hidden />
        ) : (
          <Copy strokeWidth={2} aria-hidden />
        )}
      </button>
    </div>
  );
}
